import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const styles = {
  fontFamily: "Manrope",
  fontWeight: "500",
  fontStyle: "normal",
  textDecoration: "none",
};
const lableStyles = {
  fontFamily: "Manrope",
  fontWeight: "800",
  fontStyle: "normal",
  textDecoration: "none",
};
const CancelBtnStyle = {
  backgroundColor: "var(--ShadeGray800)",
  color: "white",
  borderRadius: ".5rem",
  padding: "4px 22px",
  outline: "1px solid var( --white-20)",
};

const CurrentPlanMoreInfoDetails = ({
  planPurchaseDate,
  subscription_status,
  expiryString,
  renewalString,
}) => {
  const commonReducer = useSelector((state) => state?.commonReducer);
  const currentPlan = commonReducer?.currentPlan;

  const navigate = useNavigate();
  const { projectId } = useParams();
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const segment = pathSegments[2];

  const navigateHandler = () => {
    if (segment === "card") {
      navigate("/more_info", {
        state: {
          isRender: true,
          isMoreInfo: true,
          isCard: true,
          projectId: projectId,
        },
      });
      // setIsPlanShow(true);
    } else {
      navigate("/more_info", {
        state: {
          isRender: true,
          isMoreInfo: true,
          isCard: false,
          projectId: projectId,
        },
      });
      // setIsPlanShow(true);
    }
  };


  return (
    <div
      className="h-full w-[45%] flex jus py-[15px] px-[25px] flex-col SubBox1"
      style={{
        border: "1px solid #ffffffcc",
        borderRadius: "1rem",
        color: "#f8f8f6",
      }}
    >
      <div className="w-full h-[100px] pl-[.25rem]  pr-[10px] flex justify-evenly flex-col">
        <div className="flex items-center">
          <p
            className="lg:text-[1.3rem] text-[0.9rem] mt-[-3px]"
            style={lableStyles}
          >{`Your Plan Details`}</p>
        </div>

        <div className="">
          <p
            className="sm:leading-[1.125rem] priceCubetext  tracking-wide text-[14px]"
            style={styles}
          >
            {planPurchaseDate
              ? `${currentPlan?.plan?.status === 'trialing' ? 'Trial start date ' : 'Subscription Purchase '}${planPurchaseDate}`
              : null}
          </p>

          {subscription_status === 2 ? (
            <p
              className="sm:leading-[1.125rem] priceCubetext  tracking-wide text-[14px]"
              style={styles}
            >
              {expiryString}
            </p>
          ) : (
            <p
              className="sm:leading-[1.125rem] priceCubetext  tracking-wide text-[14px]"
              style={styles}
            >
              {renewalString}
            </p>
          )}
        </div>
      </div>

      <div className="flex justify-end  mt-2 h-[40px]">
        <div className="flex items-center p-1 ">
          <button
            className=" manrope-800 sm:text-base px-[22px] py-[4px]"
            style={CancelBtnStyle}
            onClick={navigateHandler}
          >
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default CurrentPlanMoreInfoDetails;
